<template>
    <div>
        <template v-if="!loading">
            <div class="box">
                <h3><i></i>知识点掌握率</h3>
                <div class="scoreChartWarp">
                    <div id="scoreChart"
                         :style="echartStyle"></div>
                </div>
            </div>
            <ul v-if="list.length">
                <li v-for="l in list"
                    @click="goto(l)">
                    <p>{{l.name}}</p>
                    <div>知识点掌握率{{l.k_right_rate}}%</div>
                </li>
            </ul>
        </template>
        <loadings v-else></loadings>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import loadings from "COMPONENTS/base/loadingS.vue";
export default {
    props: ['sid', 'message_id', 'unit_class_id'],
    data () {
        return {
            list: [],
            XData: [],
            barData: [],
            lineData: [],
            loading: true,
            echartStyle: {
                width: '15rem',
                height: '9.5rem'
            },
            lineArray: [],
        }
    },
    components: {
        loadings,
    },
    created () {
        let url = '', data = {};
        if (this.$route.query.testType == "qz") {
            url = API_URL_HD_API + "/qz2022/tea/knowledge_detail"
            data = {
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }

        } else if (this.$route.query.taskType == "2022winter") {
            url = API_URL_HD_API + "/winter2022/tea/knowledge_detail"
            data = {
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }
        } else if (this.$route.query.taskType == "2023winter" || this.$route.query.taskType == "2024winter") {
            url = API_URL_HD_API + "/winter2023/tea/knowledge_detail"
            data = {
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }
        }
        else if (this.$route.query.testType == "qm") {
            url = API_URL_HD_API + "/qm2022_down/tea/knowledge_detail"

            data = {
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }

        } else if (this.$route.query.testType == "2023kxjc") {
            url = API_URL_HD_API + "/kxjc2023/tea/knowledge_detail"
            data = {
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }

        } else if (this.$route.query.taskType == "2023jdjc") {
            url = API_URL_HD_API + "/common/tea/knowledge_detail"
            data = {
                "hd_type": 5,
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }
        } else if (this.$route.query.hd_type) {
            url = API_URL_HD_API + "/common/tea/knowledge_detail"
            data = {
                "hd_type": this.$route.query.hd_type,
                "paper_id": this.message_id,
                "sid": this.sid,
                "unit_class_id": this.unit_class_id
            }
        } else {


            if (this.sid == 21) {
                url = API_URL_TASK_API + "/maths/check/special/task_knowledge_detail/"
            }
            if (this.sid == 51) {
                url = API_URL_TASK_API + "/chinese/check/special/task_knowledge_detail/"
            }
            data = {
                message_id: this.message_id,
                unit_class_id: this.unit_class_id
            }
        }
        this.$http.post(url, data).then(res => {
            this.loading = false;
            if (res.data.response == 'ok') {
                res = res.data;
                this.list = res.data;
                this.list.forEach(l => {
                    this.XData.push(l.name);
                    this.barData.push(l.k_right_rate);
                    this.lineData.push(l.unit_rate);
                    let num = Math.ceil(l.name.length / 3);
                    this.lineArray.push(num);
                })
                if (this.XData.length) {
                    let n = Math.ceil(this.XData.length / 8);
                    this.echartStyle.width = Number(15 * n) + 'rem';
                    let num = Math.max(...this.lineArray);
                    this.echartStyle.height = Number(10.5 + 0.5 * num) + 'rem';
                } else {
                    this.XData.push('无内容')
                }
                this.$nextTick(function () {
                    if (this.sid == 21 || this.sid == 22) {
                        MathJax.Hub.Typeset(document.body)
                    }
                    this.initChart()
                })
            }
        })

    },
    mounted () {

    },
    methods: {
        initChart () {
            let chartDom = document.getElementById('scoreChart');
            let myChart = echarts.init(chartDom);
            let _this = this;
            let option = {
                // tooltip: {
                //     trigger: 'axis',
                //     axisPointer: {
                //         type: 'cross',
                //         crossStyle: {
                //             color: '#999'
                //         }
                //     }
                // },
                grid: {
                    left: '0.5rem',
                    right: '-40rem',
                    bottom: '0.5rem',
                    containLabel: true
                },
                legend: {
                    selectedMode: false,
                    data: ['班级平均', '年级平均'],
                    right: '1%'
                },
                xAxis: [{
                    type: 'category',
                    data: _this.XData,
                    axisLine: {
                        show: false //不显示横轴线
                    },
                    axisTick: {
                        alignWithLabel: true, //柱状图中心是否对齐刻度位置
                        show: false //不显示刻度
                    },
                    //  axisLabel:{
                    //      interval: 0,
                    //      rotate:45
                    //  }
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            var ret = "";//拼接加\n返回的类目项  
                            var maxLength = 3;//每项显示文字个数  
                            var valLength = value.length;//X轴类目项的文字个数  
                            var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
                            if (rowN > 1)//如果类目项的文字大于5,  
                            {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = "";//每次截取的字符串  
                                    var start = i * maxLength;//开始截取的位置  
                                    var end = start + maxLength;//结束截取的位置  
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串  
                                }
                                return ret;
                            }
                            else {
                                return value;
                            }
                        },
                        textStyle: {
                            fontSize: '10'      //更改坐标轴文字大小
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }, {
                    type: 'value',
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    }
                }],
                series: [{
                    name: '班级平均',
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'top'
                    },
                    itemStyle: {
                        color: '#3c7cfb'
                    },
                    data: _this.barData
                }, {
                    name: '年级平均',
                    type: 'line',
                    yAxisIndex: 1,
                    itemStyle: {
                        color: '#8cd33b'
                    },
                    data: _this.lineData
                }]
            };
            option && myChart.setOption(option);
        },
        goto (k) {
            localStorage.setItem('teaTaskKnowledg', JSON.stringify(k))
            this.$router.push(`/personaLearning/knowledgDetail?sid=${this.sid}&kid=${k.kid}`)
        }
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 30px / $ppr auto 30px / $ppr;
    background: #fff;
    padding: 25px / $ppr 30px / $ppr 30px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("../img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
            // vertical-align: middle;
            // margin-right:16px/$ppr;
        }
    }
}
ul li {
    width: 600px / $ppr;
    padding: 25px / $ppr 30px / $ppr 24px / $ppr;
    background: #fff;
    border-radius: 16px / $ppr;
    margin: 0 auto 30px / $ppr;
    font-size: 28px / $ppr;
    h3 {
        line-height: 54px / $ppr;
        height: 54px / $ppr;
        font-size: 28px / $ppr;
        margin-bottom: 10px / $ppr;
    }
    p {
        line-height: 48px / $ppr;
    }
    div {
        color: #999;
        font-size: 24px / $ppr;
        line-height: 48px / $ppr;
        padding-top: 10px / $ppr;
        span {
            display: block;
            float: left;
            &:nth-child(2) {
                float: right;
            }
        }
    }
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
</style>